module.exports = __webpack_public_path__ + "img/202410_04.dfd2ecd8.jpg";